import { Form, message, Space, Spin, Table, Tooltip } from 'antd';
import { calculateColumnsWidth } from 'api/common';
// import { AuditLog } from 'api/dashboard';
// import { LoadingScreen } from 'common/components';
import { useEffect, useState } from 'react';
import {
  FilterPayload,
  getPaymentRequestHistoryList,
  PaymentListData,
  PaymentPagedList,
} from 'api/paymentRequestHistory';
import moment from 'moment';
import { ColumnsType } from 'antd/lib/table';

type Props = {
  filter: FilterPayload;
};

const FilteredList = ({ filter }: Props) => {
  const initialPagedList: PaymentPagedList = {
    data: [],
    noOfRecords: 0,
    currentPageIndex: 1,
  };

  // const initialAudit: AuditResponse = {
  //   data: [],
  // };

  const [_form] = Form.useForm<FilterPayload>();
  const [pagedList, setPagedList] = useState(initialPagedList);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const isAdmin = sessionStorage.getItem('isAdmin');
  if (isAdmin !== 'true') {
    filter.sourceApplicationName = sessionStorage.getItem('source')?.toString();
  }

  const getFullDate = (date: string) => {
    if (date) {
      return moment(new Date(date)).format('DD/MM/YYYY HH:mm:ss');
    }
    return '';
  };

  useEffect(() => {
    fetchData();
  }, [filter]);

  const fetchData = () => {
    setIsLoading(true);
    filter.pageNo = 1;
    filter.pageSize = 10;
    filter.isExtract = false;
    getPaymentRequestHistoryList(filter)
      .then((res) => {
        // Ensure data is always an array, even if the API returns null or undefined
        const data = res.data?.data || [];
        setPagedList({
          data,
          noOfRecords: res.data?.noOfRecords || 0,
          currentPageIndex: filter.pageNo,
        });
      })
      .catch((error) => {
        console.error('Failed to fetch payment request history:', error);
        message.error('Failed to fetch payment request history. Please try again later.');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleChange = (pagination: any, _filters: any, sorter: any) => {
    setIsLoading(true);

    const updatedFilter = {
      ...filter,
      pageNo: pagination.current,
      pageSize: 10,
    };

    if (sorter.field) {
      // Handle sorting logic if needed
      // updatedFilter.sortField = sorter.field;
      // updatedFilter.sortOrder = sorter.order;
    }

    // Update the filter and fetch new data
    getPaymentRequestHistoryList(updatedFilter)
      .then((res) => {
        const data = res.data?.data || [];
        setPagedList({
          data,
          noOfRecords: res.data?.noOfRecords || 0,
          currentPageIndex: updatedFilter.pageNo,
        });
      })
      .catch((error) => {
        console.error('Failed to fetch payment request history:', error);
        message.error('Failed to fetch payment request history. Please try again later.');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const maxWidthPerCell = 1000;
  const paymentColumns: ColumnsType<PaymentListData> = [
    {
      key: 'RequestID',
      title: 'Request ID',
      dataIndex: 'RequestID',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'RequestType',
      title: 'Request Type',
      dataIndex: 'RequestType',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'PaymentRequestJson',
      title: 'Payment Request',
      dataIndex: 'PaymentRequestJson',
      ellipsis: true,
      render: (_) => (
        <Tooltip placement="topLeft" title={_}>
          {_}
        </Tooltip>
      ),
    },
    {
      key: 'PaymentResponseJson',
      title: 'Payment Response',
      dataIndex: 'PaymentResponseJson',
      ellipsis: true,
      render: (_) => (
        <Tooltip placement="topLeft" title={_}>
          {_}
        </Tooltip>
      ),
    },
    {
      key: 'RequestDate',
      title: 'Request Date',
      dataIndex: 'RequestDate',
      ellipsis: true,
      render: (date: string) => getFullDate(date),
    },
    {
      key: 'Action',
      title: 'Action',
      dataIndex: 'Action',
      render: (_text) => (
        <Space direction="vertical">
          {/* <Button className="ant-btn ant-btn-primary" size="small">
            AUDIT LOG
          </Button>
          {record.RequestStatus === 'RECEIPT_FAILED' && (
            <Button className="ant-btn ant-btn-primary" size="small" style={{ marginLeft: '20px' }}>
              RETRY
            </Button>
          )} */}
        </Space>
      ),
    },
  ];

  // const auditColumns: ColumnsType<AuditLog> = [
  //   {
  //     key: 'LANumber',
  //     title: 'Loan Number',
  //     dataIndex: 'LANumber',
  //     width: 80,
  //   },
  //   {
  //     key: 'Event',
  //     title: 'Event',
  //     dataIndex: 'Event',
  //     width: 300,
  //   },
  //   {
  //     key: 'EventDateTime',
  //     title: 'Event Date & Time',
  //     dataIndex: 'EventDateTime',
  //     width: 100,
  //     render: (date: string) => getFullDate(date),
  //   },
  //   {
  //     key: 'ErrorDescription',
  //     title: 'Error Description',
  //     dataIndex: 'ErrorDescription',
  //     width: 100,
  //   },
  // ];

  const dataTable = calculateColumnsWidth(paymentColumns, pagedList.data || [], maxWidthPerCell);
  const tableHeight = 500;
  const rowKey = 'ROWNUM';

  // const handleOk = () => {
  //   setIsModalOpen(false);
  // };

  // const handleCancel = () => {
  //   setIsModalOpen(false);
  // };

  return (
    <>
      <Spin spinning={isLoading}>
        <Table
          columns={dataTable.columns}
          dataSource={dataTable.source}
          rowKey={rowKey}
          scroll={{ x: dataTable.tableWidth, y: tableHeight }}
          pagination={{
            pageSize: filter.pageSize,
            total: pagedList.noOfRecords,
            current: pagedList.currentPageIndex,
          }}
          onChange={handleChange}
        />
      </Spin>
      {/* <Modal
        title="Audit Log"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width="auto"
        footer={[<div key="footer"></div>]}
      > */}
      {/* <div>
          {isModalLoading ? (
            <LoadingScreen />
          ) : (
            <Table<AuditLog>
              dataSource={auditLog?.data || []}
              columns={auditColumns}
              scroll={{ x: 2000, y: 500 }}
              pagination={false}
            />
          )}
        </div> */}
      {/* </Modal> */}
    </>
  );
};

export default FilteredList;
